module.exports = __webpack_public_path__ + "img/img19.83fc3f4a.jpg";